import { Label } from 'components';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { connect } from 'react-redux';

interface IToggleInput {
  checked: boolean;
  onChange: (checked: boolean) => void;
  name: string;
}

const ToggleInput: FC<IToggleInput> = ({ checked, onChange, name }) => {
  const t = useTranslations();

  return (
    <div className="mb-3">
      <input
        className="tradio"
        type="radio"
        name={name}
        id={`${name}_yes`}
        value={'yes'}
        checked={checked}
        onChange={() => onChange(true)}
      />
      <Label name={`${name}_yes`} className="!my-0 mr-3">
        {t('ordering_form.yes')}
      </Label>
      <input
        className="tradio"
        type="radio"
        name={name}
        id={`${name}_no`}
        value={'no'}
        checked={!checked}
        onChange={() => onChange(false)}
      />
      <Label name={`${name}_no`} className="!my-0">
        {t('ordering_form.no')}
      </Label>
    </div>
  );
};

export default connect()(ToggleInput);
